(function () {
  function initMobileCarousel(root) {
    if (root.dataset.relatedMobileReady === 'true') return;
    root.dataset.relatedMobileReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-related-mobile-slide]'));
    if (!slides.length) return;

    var section = root.closest('product-recommendations');
    var prev = section ? section.querySelector('[data-related-mobile-prev]') : null;
    var next = section ? section.querySelector('[data-related-mobile-next]') : null;
    var current = section ? section.querySelector('[data-related-mobile-current]') : null;
    var total = section ? section.querySelector('[data-related-mobile-total]') : null;
    var index = 0;

    if (total) total.textContent = String(slides.length);

    function render(activeIndex) {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('magio-related-mobile-slide--hidden', i !== activeIndex);
        slide.setAttribute('aria-hidden', i !== activeIndex ? 'true' : 'false');
      });

      if (current) current.textContent = String(activeIndex + 1);
      if (prev) prev.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        if (index > 0) {
          index -= 1;
          render(index);
        }
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        if (index < slides.length - 1) {
          index += 1;
          render(index);
        }
      });
    }

    render(0);
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-magio-related-mobile-carousel]')
      .forEach(initMobileCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.querySelectorAll('product-recommendations.related-products--magio-cards').forEach(function (el) {
    var observer = new MutationObserver(function () {
      initAll(el);
    });
    observer.observe(el, { childList: true, subtree: true });
  });
})();
